import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { aiFailedStateMessages } from '@atlaskit/editor-common/ai-messages';
import { Text } from '@atlaskit/primitives/compiled';
import { FAILURE_REASON } from './errors';
var knownErrorMessages = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FAILURE_REASON.UNKNOWN, aiFailedStateMessages.documentInsertError), FAILURE_REASON.TOKEN_LIMIT, aiFailedStateMessages.tokenLimitExceeded), FAILURE_REASON.INSERT_FAILURE, aiFailedStateMessages.documentInsertError), FAILURE_REASON.INPUT_TOO_SHORT, aiFailedStateMessages.inputTooShortError), FAILURE_REASON.HIPAA_CONTENT, aiFailedStateMessages.hipaaContentError), FAILURE_REASON.RATE_LIMITED, aiFailedStateMessages.rateLimitEnforced), FAILURE_REASON.AUP_VIOLATION, aiFailedStateMessages.aupViolationMessage), FAILURE_REASON.ELEVATE_DISABLED_GENERATE, aiFailedStateMessages.elevateDisabledGenerateError), FAILURE_REASON.INTERNAL_SERVER_ERROR, aiFailedStateMessages.internalServerError), FAILURE_REASON.API_FAIL, aiFailedStateMessages.apiError);
export var documentationUrls = _defineProperty(_defineProperty(_defineProperty({}, FAILURE_REASON.INTERNAL_SERVER_ERROR, 'https://status.atlassian.com/'), FAILURE_REASON.AUP_VIOLATION, 'https://www.atlassian.com/legal/acceptable-use-policy'), FAILURE_REASON.RATE_LIMITED, 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/');

// Use of links in messages is based on guidance at https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
var LinkedMessage = function LinkedMessage(_ref) {
  var error = _ref.error,
    documentationUrl = _ref.documentationUrl;
  return /*#__PURE__*/React.createElement(FormattedMessage
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, knownErrorMessages[error], {
    values: {
      link: function link(message) {
        return /*#__PURE__*/React.createElement("a", {
          href: documentationUrl,
          target: "_blank",
          rel: "noopener noreferrer"
        }, message);
      }
    }
  }));
};

// 500 status codes should not be retryable
var is5xxErrorRange = function is5xxErrorRange(statusCode) {
  return statusCode >= 500 && statusCode < 600;
};
export var retryEnabled = function retryEnabled(_ref2) {
  var failureReason = _ref2.failureReason,
    _ref2$statusCode = _ref2.statusCode,
    statusCode = _ref2$statusCode === void 0 ? 500 : _ref2$statusCode;
  return failureReason === FAILURE_REASON.API_FAIL && !is5xxErrorRange(statusCode);
};
export var getStepName = function getStepName(_ref3) {
  var apiName = _ref3.apiName,
    failureReason = _ref3.failureReason;
  return apiName === 'assistance-service' || failureReason === FAILURE_REASON.AUP_VIOLATION || failureReason === FAILURE_REASON.API_FAIL ? 'apiError' : 'failed';
};
export var ErrorMessage = function ErrorMessage(_ref4) {
  var errorKey = _ref4.errorKey,
    failureReason = _ref4.failureReason,
    statusCode = _ref4.statusCode;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var isConvoAIServerError = ['FEATURE_DISABLED', 'FEATURE_DISABLED_ON_SITE', 'NO_AGENT'].includes(errorKey || '');

  // 9001 is a special case for elevate where we disable generate until Q3
  if (statusCode === 9001) {
    return /*#__PURE__*/React.createElement(Text, null, formatMessage(knownErrorMessages['elevate disabled generate']));
  }
  if (statusCode && is5xxErrorRange(statusCode) || isConvoAIServerError || failureReason === FAILURE_REASON.INTERNAL_SERVER_ERROR) {
    return /*#__PURE__*/React.createElement(LinkedMessage, {
      error: FAILURE_REASON.INTERNAL_SERVER_ERROR,
      documentationUrl: documentationUrls[FAILURE_REASON.INTERNAL_SERVER_ERROR]
    });
  }
  if (!failureReason) {
    return /*#__PURE__*/React.createElement(Text, null, formatMessage(knownErrorMessages['unknown fail']));
  }
  if (failureReason === FAILURE_REASON.AUP_VIOLATION) {
    return /*#__PURE__*/React.createElement(LinkedMessage, {
      error: FAILURE_REASON.AUP_VIOLATION,
      documentationUrl: documentationUrls[FAILURE_REASON.AUP_VIOLATION]
    });
  }
  if (failureReason === FAILURE_REASON.RATE_LIMITED) {
    return /*#__PURE__*/React.createElement(LinkedMessage, {
      error: FAILURE_REASON.RATE_LIMITED,
      documentationUrl: documentationUrls[FAILURE_REASON.RATE_LIMITED]
    });
  }
  return /*#__PURE__*/React.createElement(Text, null, formatMessage(knownErrorMessages[failureReason]));
};